import { createTheme } from '@mui/material/styles';

// The app styles almost everything through styled-components and does not mount
// a MUI ThemeProvider of its own, so MUI overlays run on MUI's default theme.
// This minimal theme exists to carry cross-cutting MUI defaults.
//
// disableScrollLock stops MUI's Modal-based overlays (Menu, Popover, Select,
// and our PopoverMenu) from locking body scroll. The scroll lock removes the
// page scrollbar and compensates by adding `padding-right` to <body>, which
// showed up as a white vertical bar on the right of the screen whenever the
// underlying page had a scrollbar.
const muiTheme = createTheme({
  components: {
    MuiPopover: {
      defaultProps: {
        disableScrollLock: true,
      },
    },
    MuiMenu: {
      defaultProps: {
        disableScrollLock: true,
      },
    },
  },
});

export default muiTheme;
